module.exports = __webpack_public_path__ + "static/media/gd-goenka .0c4c557b.png";